import React, {forwardRef} from 'react';
import styled, {keyframes} from 'styled-components';
import {COLORS} from '../../../constants/colors';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const Spinner = styled.div`
  display: inline-block;
  position: relative;
  width: 4rem;
  height: 4rem;
`;

const frames = keyframes`
   0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

interface RingProps {
  $delay: number;
  $color?: string;
  $size?: string;
}

const SpinnerElement = styled.div<RingProps>`
  box-sizing: border-box;
  position: absolute;
  width: ${({$size}) => $size};
  height: ${({$size}) => $size};
  margin: 6px;
  border-radius: 50%;
  border: 4px solid ${({$color}) => $color || COLORS.Black};
  animation: ${frames} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: -${({$delay}) => $delay};
  border-color: ${({$color}) => $color || COLORS.Black} transparent transparent
    transparent;
`;

export const LoadingSpinner = forwardRef<
  HTMLDivElement,
  {
    color?: string;
    size?: string;
    className?: string;
    style?: React.CSSProperties;
  }
>(function LoadingSpinner({color, size = '51px', className, style}, ref) {
  return (
    <Container className={className} style={style} ref={ref}>
      <Spinner>
        <SpinnerElement $delay={0.45} $color={color} $size={size} />
        <SpinnerElement $delay={0.3} $color={color} $size={size} />
        <SpinnerElement $delay={0.15} $color={color} $size={size} />
      </Spinner>
    </Container>
  );
});
